/*
 * Pestaña Tendencia: compara el pendiente actual contra los snapshots
 * guardados, replica del tab-tendencia del HTML original.
 */
import { useMemo } from "react";
import { Description, Select } from "codekit";

import Linechrt from "./Linechrt";
import Panelbox from "./Panelbox";
import { fmtCOP, htmlTheme } from "./utils/carthelp";

/**
 * Renderiza la pestaña Tendencia
 * @param {Object} props Propiedades del componente
 * @param {Object} props.snapshots Historico guardado (etiqueta → snapshot)
 * @param {string} props.compare Snapshot elegido para comparar en los KPIs
 * @param {Function} props.onCompare Cambia el snapshot de comparacion
 * @param {number} props.total Pendiente de la carga actual
 */
const Tabtrend = ({ snapshots, compare, onCompare, total }) => {
  const mKeys = useMemo(() => Object.keys(snapshots).sort(), [snapshots]);
  const mPoints = useMemo(
    () => [
      ...mKeys.map((sKey) => ({ label: sKey, value: snapshots[sKey].total })),
      { label: "Actual", value: total },
    ],
    [mKeys, snapshots, total],
  );
  const mOptions = [...mKeys]
    .reverse()
    .map((sKey) => ({ value: sKey, text: `${sKey} (${fmtCOP(snapshots[sKey].total)})` }));

  return (
    <Panelbox
      title="Tendencia del Pendiente Total (histórico de cargas)"
      hint="Comparación entre snapshots guardados mes a mes"
    >
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
        <span style={{ color: htmlTheme.muted }}>
          <Description variant="description-3">Comparar carga actual contra:</Description>
        </span>
        <div style={{ minWidth: 240 }}>
          <Select options={mOptions} value={compare} onChangeValue={({ option }) => onCompare(option.value)} />
        </div>
      </div>
      <Linechrt data={mPoints} height={300} />
    </Panelbox>
  );
};

export default Tabtrend;
